import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLButtonElement> {
  static readonly values = {
    formName: String,
  };

  declare readonly formNameValue: string;
  declare readonly hasFormNameValue: boolean;

  submit(event: PointerEvent) {
    event.preventDefault();

    if (this.hasFormNameValue) {
      const form = document.querySelector(`form[name="${this.formNameValue}"]`);
      if (form && form instanceof HTMLFormElement) {
        form.requestSubmit();
      }
    }
  }
}
